export function hasPermission(permissions, [requiredGroup, requiredRole]) {
  if (!Array.isArray(permissions)) return false;

  return permissions.some(([group, role]) =>
    group === requiredGroup && role === requiredRole
  );
}
